import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Model } from '@app/shared/models/model.model';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { Campaign } from '@app/campaign/campaign.model';

@Injectable({
  providedIn: 'root',
})
export class CampaignService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery(), keywords: string = null): Observable<PaginatedResponse> {
    const options = query.buildGetOptions();
    if (keywords) {
      options.params = options.params.set('keywords', keywords);
    }

    return this.http.get('v1/campaign', options).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((request: any) => {
          return new Campaign().deserialize(request);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(request: Campaign): Observable<Campaign> {
    return this.http.put('v1/campaign/' + request.id, request).pipe(
      map((response: HttpResponse) => {
        return new Campaign().deserialize(response.data);
      })
    );
  }

  store(request: Campaign): Observable<Campaign> {
    return this.http.post('v1/campaign', request).pipe(
      map((response: HttpResponse) => {
        return new Campaign().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/campaign/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Campaign().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/campaign/' + id);
  }

  send(requests: any): Observable<any> {
    return this.http.post('v1/campaign/send', requests).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
